import React from 'react';
import { Container, Row, Col } from 'reactstrap'
import Header from '../../Componentes/header'
import Nav from '../../Componentes/nav'
import Footer from '../../Componentes/footer'
import '../../CSS/bootstrap.min.css'
import '../../CSS/style.css'

export default class InicioAdmin extends React.Component {
    
    render() {
        return (
            <html>
                <Header/>
                <Row>
                    <Col className="bg-light" lg="3">
                        <Nav usuario={sessionStorage.getItem('usuario')} tipo={sessionStorage.getItem('rol')}/>
                    </Col>
                    <Col className="bg-light" lg="9">
                        <h1 class="mt-4 mb-4 text-center">Inicio</h1>
                            <Container> 
                            <p className="text-justify">Bienvenido al sistema digitalizador de expedientes, esta plataforma tiene como objetivo brindar las herramientas necesarias para almacenar, digitalizar y controlar los documentos de los alumnos del <a href="http://www.itmexicali.edu.mx" className="font-weight-bold">Instituto Tecnologico de Mexicali</a> con el objetivo de llevar un control de toda documentacion tanto estudiantes que cursan actualmente la universidad como estudiantes egresados.</p>
                            </Container>
                    </Col>
                </Row>
                <Footer/>
            </html>
        )
    }
}
